import { useTranslator } from "components/Translator"
import { Text } from "components/Text"
import { ForumPostCard } from "./ForumPostCard"
import { Pagination } from "components/Pagination"

export const ForumPostsList = (props) => {
  const translator = useTranslator()

  if (props.posts.length === 0) {
    return (
      <Text variant={"body2"} tag={"p"}>
        {props.emptyLabel ??
          translator.trans("ForumPostsList.empty", null, "components")}
      </Text>
    )
  }

  return (
    <div className={"grid gap-8"}>
      <ul className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"}>
        {props.posts.map((post) => (
          <li key={post.id} aria-label={post.title}>
            <ForumPostCard post={post} onFollowToggle={props.onFollowToggle} />
          </li>
        ))}
      </ul>

      {props.pagination ? (
        <Pagination
          currentPageNumber={props.pagination.currentPageNumber}
          itemNumberPerPage={props.pagination.itemNumberPerPage}
          totalItemCount={props.pagination.totalItemCount}
          pageRange={2}
        />
      ) : null}
    </div>
  )
}
